// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bill-reader/static/js/" + chunkId + "." + {"679":"f58d7462","787":"a828f7cc"}[chunkId] + ".chunk.js";
};